import { ChangeDetectionStrategy, Component, input, output, WritableSignal } from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatSelectModule } from '@angular/material/select'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatSliderModule } from '@angular/material/slider'
import { MatTooltipModule } from '@angular/material/tooltip'
import { GbDashboardSharedUiModule } from '@galabid/gb-dashboard/shared/ui'
import { TranslateModule } from '@ngx-translate/core'
import { NgScrollbarModule } from 'ngx-scrollbar'

@Component({
  selector: 'gb-presenter-view-options',
  imports: [
    MatSidenavModule,
    NgScrollbarModule,
    GbDashboardSharedUiModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSliderModule,
    MatMenuModule,
    MatDividerModule,
    TranslateModule,
  ],
  templateUrl: './gb-presenter-view-options.component.html',
  styleUrl: './gb-presenter-view-options.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterViewOptionsComponent {
  zoomLevel = input.required<WritableSignal<number>>()

  zoomChange = output<number>()
  zoomToFitChange = output<void>()
  zoomToFillChange = output<void>()

  readonly zoomPresets: number[] = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4, 5]

  formatLabel(value: number): string {
    return `${Math.round(value * 100)}%`
  }

  getZoomPercentLabel(): string {
    return `${Math.round(this.zoomLevel()() * 100)}%`
  }

  onZoomChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value
    this.zoomChange.emit(parseFloat(value))
  }

  setZoom(zoom: number): void {
    this.zoomChange.emit(zoom)
  }

  zoomToFit(): void {
    this.zoomToFitChange.emit()
  }

  zoomToFill(): void {
    this.zoomToFillChange.emit()
  }
}
